<template>
    <v-row id="buttom-row-tab">
        <v-col
            cols="auto"
            md="auto"
            sm="auto"
            class="d-flex align-center"
            id="buttom-col-tab"
        >
            <!-- <v-izmg
                v-if="organization"
                class="mr-md-4 mr-0"
                :src="`${organization?.school_logo_base64?.data}`"
                contain
                width="80"
                height="80"
            />
            <div>
                <li
                    class="form-subtitle-400"
                    style="text-align: start"
                    id="buttom-text"
                >
                    <span id="content1"
                        >{{ $t("message.footer.message1") }}
                    </span>
                    <span class="ml-md-auto ml-sm-6 ml-5" id="content2"
                        ><b>{{ openingDate }} - {{ enrollmentDate }}</b></span
                    >
                </li>
                <li
                    class="form-subtitle-400"
                    style="text-align: start"
                    id="buttom-text"
                    v-if="organization"
                >
                    <span id="content3"
                        >{{ $t("message.footer.message2") }}
                    </span>
                    <span class="ml-md-auto" id="content4"
                        ><b>{{ organization?.[`name_${locale}`] }}</b></span
                    >
                </li>
            </div> -->
        </v-col>
    </v-row>
</template> 

<script>
import * as services from "@/services";
import { formatDateTimeLocale } from "@/utils/date";
import i18n from '@/i18n';
export default {
    name: "LoginFooter",
    data: () => ({
        registrationFormDetail: {},
        organization: null,
    }),
    computed: {
        locale() {
            return i18n.locale;
        },
        openingDate() {
            let newDate = Date.parse(this.registrationFormDetail?.opening_date);
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        closingDate() {
            let newDate = Date.parse(this.registrationFormDetail?.closing_date);
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
        enrollmentDate() {
            let newDate = Date.parse(this.registrationFormDetail?.enrollment_date);
            if (newDate) return formatDateTimeLocale(newDate, this.locale);
            else return "";
        },
    },
    methods: {
        async getResource() {
            try {
                this.$emit("updateLoading", 1);
                
                let {
                    data: { data },
                } = await services.getRegisterFormIDFromLink({
                    link: localStorage.getItem("registerLink"),
                });
                this.registrationFormDetail = data.register_form_config;

                data = await services.getOrganization();
                this.organization = data.data.data.organization;
            } finally {
                this.$emit("updateLoading", -1);
            }
        },
    },
    mounted() {
        this.getResource();
    },
};
</script>